// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1UuJ8","sendOtp":"AuthorizeToLogin_sendOtp__3k7WN"};